import {useCallback} from 'react';

import {routeNames} from '~/shared/routes';
import {useLocation} from '~/shared/router';
import {signInModalOrPage} from '~/shared/services/navigation';

import {useIsMinLargeMobile} from './deviceInfo';

const ROUTES_TO_OPEN_SIGN_IN_MODAL = [
  routeNames.menu,
  routeNames.restaurants,
];

const useOpenSignIn = () => {
  const location = useLocation();
  const isMinLargeMobile = useIsMinLargeMobile();

  const createOpenSignInAction = useCallback(
    (mode: 'login' | 'signup') => () => {
      return signInModalOrPage({
        mode,
        returnUrl: location.path,
        forcePushRoute: !ROUTES_TO_OPEN_SIGN_IN_MODAL.includes(location.routeName) && isMinLargeMobile,
      });
    },
    [location, isMinLargeMobile],
  );

  return {
    openLogin: createOpenSignInAction('login'),
    openSignUp: createOpenSignInAction('signup'),
  };
};
export default useOpenSignIn;
